import { useContext } from "react"
import { useNavigate } from "react-router-dom"
import useStepNavigation from "../../hook/useStepNavigation"
import { updateGuestsConfirmAPI } from "../../api/rsvpApi"
import { GuestUpdate, RsvpDetails, StepsTranslationsStrings } from "../../models/api/rsvpApiTypes"
import { CORE_STEP_NAMES, TranslationsStringsType } from "../../models/enum/rsvpEnum"
import { LanguageContext } from "../../utils/LanguageContext"
import { toastWarning } from "../../utils/toastMethod"
import toasts from "../../json/toast.json"

interface StepRecapProps {
  buttonColor?: string
  backButtonColor?: string
  strings?: StepsTranslationsStrings[]
  rsvp: RsvpDetails
  tenant: string
  reservationCode: string | undefined
  setStep: (name: string) => void
  stepPipeline: string[]
}

export default function StepRecap({
  buttonColor,
  backButtonColor,
  strings,
  rsvp,
  tenant,
  reservationCode,
  setStep,
  stepPipeline,
}: StepRecapProps) {
  const { language } = useContext(LanguageContext)
  const navigate = useNavigate()
  const { goNext, goPrevious, goTo } = useStepNavigation(stepPipeline, CORE_STEP_NAMES.SUMMARY, setStep)

  const lang = language.language.toLowerCase()
  const toastStrings =
    toasts.translations.find((x) => x.lang === lang) === undefined
      ? toasts.translations[0]
      : toasts.translations.find((x) => x.lang === lang)

  const onSubmit = async () => {
    if (rsvp != null && rsvp.invitation != null) {
      const guestsPayload = rsvp.invitation.guests.map((guest) => ({
        id: guest.id,
        rsvp: guest.rsvp,
        answers: guest.answers ?? [],
      }))

      const guestConfirm: GuestUpdate = {
        reservationCode,
        guests: guestsPayload,
      }
      updateGuestsConfirmAPI(tenant, guestConfirm)
        .then(() => {
          goNext()
        })
        .catch(() => {
          toastWarning(toastStrings?.genericError !== undefined ? toastStrings.genericError : "error")
          navigate({ pathname: `/confirm`, search: `?wedding=${tenant}` })
        })
    }
  }

  const handleBackButton = () => {
    let hasOneGuestAccepted = false
    rsvp.invitation.guests.forEach(function (s) {
      if (s.rsvp.accepted === true) {
        hasOneGuestAccepted = true
      }
    })

    if (hasOneGuestAccepted) {
      goPrevious()
    } else {
      goTo(CORE_STEP_NAMES.RSVP)
    }
  }

  return (
    <>
      {rsvp.invitation.guests.map((guest) => (
        <div key={guest.id} style={{ display: "flex", flexDirection: "row", marginTop: "5px" }}>
          <label className="box-form-label ">
            {guest.name} {guest.surname}
          </label>
          <div style={{ alignItems: "flex-end" }}>{guest.rsvp.accepted ? "✅" : "❌"}</div>
        </div>
      ))}
      <div style={{ display: "flex", flexDirection: "row" }}>
        <button
          style={{ backgroundColor: backButtonColor, borderColor: backButtonColor }}
          type="button"
          className="btn btn-primary box-button-left"
          onClick={() => handleBackButton()}
        >
          {strings?.find((x) => x.type === TranslationsStringsType.LEFTBUTTON)?.value}
        </button>
        <button
          type="button"
          className="btn btn-primary box-button-right"
          style={{ backgroundColor: buttonColor, borderColor: buttonColor }}
          onClick={onSubmit}
        >
          {strings?.find((x) => x.type === TranslationsStringsType.MAINBUTTON)?.value}
        </button>
      </div>
    </>
  )
}
